/*! @azure/msal-browser v2.22.1 2022-03-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.22.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
